"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listCorrectionApprovalsQuerySchema = exports.correctionApprovalViewEnum = exports.correctionApprovalDomainEnum = exports.listCorrectionRequestsQuerySchema = exports.verifyCorrectionSchema = exports.setCorrectionDesignationsSchema = void 0;
/**
 * Request contracts for the CORRECTION WORKFLOW — the three-stage path every receipt
 * correction now takes (desk, 2026-10-05):
 *
 *   1. REQUEST    entered by a front-desk user (the existing request endpoints);
 *   2. VERIFY     by a user an administrator has selected as a Verifier;
 *   3. APPROVE    by a user an administrator has selected as an Approver.
 *
 * Verifiers and Approvers are NAMED USERS, set in Administration → Correction Workflow —
 * not roles — and the three people on one request must all be different (the server
 * refuses otherwise). A verifier's rejection is final.
 */
const zod_1 = require("zod");
const financial_payment_correction_request_1 = require("./financial-payment-correction.request");
/** Replaces BOTH sets in one save, so the two lists can never be saved out of step with each other. */
exports.setCorrectionDesignationsSchema = zod_1.z.object({
    verifierUserIds: zod_1.z.array(zod_1.z.string().uuid()).min(1, 'Select at least one verifier').max(50),
    approverUserIds: zod_1.z.array(zod_1.z.string().uuid()).min(1, 'Select at least one approver').max(50),
});
/** The verifier's note is optional — "checked against the counter register" is the usual one. */
exports.verifyCorrectionSchema = zod_1.z.object({
    note: zod_1.z.string().trim().max(2000).optional(),
});
exports.listCorrectionRequestsQuerySchema = zod_1.z.object({
    status: financial_payment_correction_request_1.paymentCorrectionStatusEnum.optional(),
    /** Only the requests I raised — what a front-desk user sees. Without it the caller must be a verifier, an approver or an overseer. */
    mine: zod_1.z.preprocess((value) => (value === 'true' || value === true ? true : value === 'false' || value === false ? false : value), zod_1.z.boolean().optional()),
    limit: zod_1.z.coerce.number().int().positive().max(200).default(100),
});
/**
 * THE MODIFICATIONS MODULE's list — the approvers' own screen (desk, 2026-10-07: "only approve flow should act in this
 * modification module"). Only a selected APPROVER may ask for it; it is a different question from `listCorrectionRequestsQuerySchema`
 * (the verifiers' work list) and is answered by a different rule on the server.
 *
 *   domain  which family: OP (OP receipts, walk-ins, consultations), IP (advances) or PATIENT (a registered patient's details — the retired
 *           direct Patient Edit, desk 2026-10-07)
 *   view    waiting = verified and awaiting this decision; approved / rejected = decided after verification (a request a verifier
 *           rejected never reached an approver, so it is not shown here)
 */
exports.correctionApprovalDomainEnum = zod_1.z.enum(['OP', 'IP', 'PATIENT']);
exports.correctionApprovalViewEnum = zod_1.z.enum(['waiting', 'approved', 'rejected']);
exports.listCorrectionApprovalsQuerySchema = zod_1.z.object({
    domain: exports.correctionApprovalDomainEnum,
    view: exports.correctionApprovalViewEnum.default('waiting'),
    limit: zod_1.z.coerce.number().int().positive().max(200).default(100),
});
//# sourceMappingURL=financial-correction-workflow.request.js.map